(function () {
    'use strict';

    function updateMTWModalSize(_target) {
        var container = $('.interactive .interactive-modal');
        var containerHeight = container.height();
        var modalHeight = container.find('.modal-item[data-target=' + _target + ']').height();
        if (modalHeight > containerHeight) {
            $('.modal-parent').addClass('scrollable').mCustomScrollbar({
                axis: 'y',
                mouseWheel: {
                    enable: true
                }
            });
        } else {
            $('.modal-parent').removeClass('scrollable').mCustomScrollbar('destroy')
        }
    }

    $(document).ready(function () {
        if ($('.homepage').length) {

            //swipers
            var bannerContentSwiper = new Swiper('.banner-content-swiper', {
                navigation: {
                    nextEl: $('.homepage .top .swiper-button-next'),
                    prevEl: $('.homepage .top .swiper-button-prev'),
                },
            });
            var videosSwiper = new Swiper('.videos-swiper', {
                effect: 'fade'
            });

            bannerContentSwiper.controller.control = videosSwiper;
            videosSwiper.controller.control = bannerContentSwiper;

            // main image marks
            $('.main-image .mark').on('click', function () {
                if (!$(this).hasClass('open')) {
                    //open details
                    $('.mark.open').removeClass('open');
                    $(this).addClass('open');

                    if ($(window).width() >= 768) {
                        $('.mark.open').next('.details').fadeOut();
                        $('.main-image .point.active').removeClass('active').find('.details').fadeOut();
                        $(this).parent().addClass('active');
                        $(this).next('.details').fadeIn();
                    } else {
                        var targetID = $(this).data('mobile-target');
                        var target = $('#mobile-details-' + targetID);
                        var allActive = $('.main-image .mobile-details.active');

                        if (allActive.length) {
                            allActive.removeClass('active').fadeOut(function () {
                                target.fadeIn().addClass('active');
                                $('html, body').animate({
                                    scrollTop: target.offset().top - 80
                                }, 500);
                            });
                        } else {
                            target.fadeIn().addClass('active');
                            $('html, body').animate({
                                scrollTop: target.offset().top - 80
                            }, 500);
                        }
                        $(this).parent().addClass('active');
                    }
                } else {
                    //close details
                    $(this).removeClass('open');
                    $(this).parent().removeClass('active');
                    if ($(window).width() >= 768) {
                        $(this).next('.details').fadeOut();
                    } else {
                        $('.main-image .mobile-details.active').fadeOut().removeClass('active');
                    }
                }
            });

            $('.main-image .point .close').on('click', function () {
                $(this).parent().fadeOut()
                    .parent().removeClass('active')
                    .find('.mark').removeClass('open')

            });

            $('.main-image .mobile-details .close').on('click', function () {
                var parent = $(this).parent();
                var pointID = parent.attr('id').slice(-1);
                var mark = $('.mark[data-mobile-target=' + pointID + ']');
                mark.removeClass('open');
                mark.parent().removeClass('active');
                parent.fadeOut().removeClass('active');
            });


            // tabs
            $('#homepageTabs').on('show.bs.tab', function (event) {
                $('#homepageTabsImages .tab-pane.show.active').removeClass('show');
                setTimeout(function () {
                    $('#homepageTabsImages .tab-pane.active').removeClass('active');
                    $(event.target.getAttribute('data-also')).addClass('show active');
                }, 150);
            });


            //sliding columns
            $('.move-columns').on('click', function () {
                var main = $('.years .main');

                if (main.hasClass('active')) {
                    main.removeClass('active').find('.column').removeClass('moved');
                    $('.new-content').fadeOut(500, function () {
                        $('.old-content').fadeIn(500);
                    });
                    if ($(window).width() > 1199) {
                        $('.column:not(.last-column)').css('transform', 'translateX(0)');
                        $('.last-column').css('transform', 'translateX(0)');
                    } else {

                    }
                } else {
                    main.addClass('active').find('.column').addClass('moved');
                    $('.old-content').fadeOut(500, function () {
                        $('.new-content').fadeIn(500);
                    });
                    if ($(window).width() > 1199) {
                        $('.column:not(.last-column)').css('transform', 'translateX(66.60%)');
                        $('.last-column').css('transform', 'translateX(-300%)');
                    } else {

                    }
                }

            });
        }
    });
}(jQuery));